import { Messages } from '../../codegen/Localize';

export function filePathDisplayStringWithBaseNameFirst(filePath: string): string {
  if (filePath) {
    let lastSeparatorIndex = filePath.lastIndexOf('/');
    if (lastSeparatorIndex < 0) {
      lastSeparatorIndex = filePath.lastIndexOf('\\');
    }
    if (lastSeparatorIndex >= 0) {
      const fileBaseName = filePath.slice(lastSeparatorIndex + 1);
      const fileDirectory = filePath.slice(0, lastSeparatorIndex);
      if (fileDirectory.length > 0) {
        const parenthesizedFileDirectory = Messages.parenthesizedArgument({ ITEM: fileDirectory });
        return `${fileBaseName} ${parenthesizedFileDirectory}`;
      } else {
        return filePath;
      }
    }
  }
  return filePath;
}

export function filePathDisplayStringWithoutBaseName(filePath: string): string {
  if (filePath) {
    let lastSeparatorIndex = filePath.lastIndexOf('/');
    if (lastSeparatorIndex < 0) {
      lastSeparatorIndex = filePath.lastIndexOf('\\');
    }
    if (lastSeparatorIndex >= 0) {
      const fileBaseName = filePath.slice(lastSeparatorIndex + 1);
      const fileDirectory = filePath.slice(0, lastSeparatorIndex);
      if (fileDirectory.length > 0) {
        return `${fileDirectory}`;
      } else {
        return filePath;
      }
    }
  }
  return filePath;
}
